export const getKeys = <T extends { [key: string]: unknown }>(
  obj: T
): (keyof T)[] => Object.keys(obj);
